function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "b",
  width: 960,
  height: 600,
  rx: 20
}), /*#__PURE__*/React.createElement("filter", {
  x: "-1.6%",
  y: "-2.5%",
  width: "103.1%",
  height: "105%",
  filterUnits: "objectBoundingBox",
  id: "a"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20 0h920c11.046 0 20 8.954 20 20v44H0V20C0 8.954 8.954 0 20 0z",
  id: "d"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-1.6%",
  y: "-23.4%",
  width: "103.1%",
  height: "146.9%",
  filterUnits: "objectBoundingBox",
  id: "c"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "14.811%",
  y1: "-22.362%",
  x2: "75.996%",
  y2: "119.406%",
  id: "e"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAD961",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF52C1",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%",
  id: "f"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00C7FA",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007DFA",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "28.973%",
  y1: "0%",
  x2: "90.2%",
  y2: "111.244%",
  id: "g"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF52C1",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9952FF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "i",
  width: 320,
  height: 512,
  rx: 17.067
}), /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-2.6%",
  width: "108.4%",
  height: "105.3%",
  filterUnits: "objectBoundingBox",
  id: "h"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.067 0h285.866C312.36 0 320 7.641 320 17.067v37.546H0V17.067C0 7.64 7.641 0 17.067 0z",
  id: "k"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-4.2%",
  y: "-24.7%",
  width: "108.4%",
  height: "149.4%",
  filterUnits: "objectBoundingBox",
  id: "j"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.145098039 0 0 0 0 0.180392157 0 0 0 0.181838768 0",
  in: "shadowBlurOuter1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10 10)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#a)",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#c)",
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00252E",
  xlinkHref: "#d"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#E1E8EE",
  x: 72,
  y: 20,
  width: 200,
  height: 24,
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(864 22)",
  fill: "#D8D8D8"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  y: 8,
  width: 32,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 32,
  height: 4,
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72 138)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#e)",
  cx: 48,
  cy: 48,
  r: 48
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(152 12)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 16,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 32,
  width: 400,
  height: 8,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 48,
  width: 366.667,
  height: 8,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 64,
  width: 333.333,
  height: 8,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(600 36)",
  fill: "#A7B9C8"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 140,
  cy: 12,
  r: 12
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72 274)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#f)",
  cx: 45,
  cy: 45,
  r: 45
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(149 9)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 16,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 32,
  width: 400,
  height: 8,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 48,
  width: 366.667,
  height: 8,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 64,
  width: 333.333,
  height: 8,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(597 33)",
  fill: "#A7B9C8"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 12,
  r: 12
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(72 417)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#g)",
  cx: 45,
  cy: 45,
  r: 45
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(149 9)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 115,
  height: 16,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 32,
  width: 400,
  height: 8,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 48,
  width: 366.667,
  height: 8,
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  y: 64,
  width: 333.333,
  height: 8,
  rx: 3
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(597 33)",
  fill: "#A7B9C8"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 12,
  r: 12
}), /*#__PURE__*/React.createElement("circle", {
  cx: 108,
  cy: 12,
  r: 12
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(706 218)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#h)",
  xlinkHref: "#i"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#i"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(706 218)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#j)",
  xlinkHref: "#k"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#00252E",
  xlinkHref: "#k"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738.133 236.773)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#E1E8EE",
  width: 104,
  height: 20.48,
  rx: 4.267
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(226.427 1.707)",
  fill: "#D8D8D8"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27.307,
  height: 3.413,
  rx: 1.707
}), /*#__PURE__*/React.createElement("rect", {
  y: 6.827,
  width: 27.307,
  height: 3.413,
  rx: 1.707
}), /*#__PURE__*/React.createElement("rect", {
  y: 13.653,
  width: 27.307,
  height: 3.413,
  rx: 1.707
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 326)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#e)",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 464)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#e)",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 372)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
})), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#f)",
  cx: 15,
  cy: 15,
  r: 15
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 510)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
})), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#f)",
  cx: 15,
  cy: 15,
  r: 15
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 418)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
})), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#g)",
  cx: 15,
  cy: 15,
  r: 15
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 556)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
})), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#g)",
  cx: 15,
  cy: 15,
  r: 15
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 602)"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "url(#e)",
  cx: 15,
  cy: 15,
  r: 15
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(738 648)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 3)",
  fill: "#E1E8EE"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57.5,
  height: 5.333,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 10.667,
  width: 200,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 183.333,
  height: 2.667,
  rx: 0.92
}), /*#__PURE__*/React.createElement("rect", {
  y: 21.333,
  width: 166.667,
  height: 2.667,
  rx: 0.92
})), /*#__PURE__*/React.createElement("circle", {
  fill: "url(#f)",
  cx: 15,
  cy: 15,
  r: 15
})));

function SvgIllustrationMockups(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 739,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMockups);
export default __webpack_public_path__ + "static/media/illustration-mockups.7b6cb4d9270f53c0f45bbf842e8ce077.svg";
export { ForwardRef as ReactComponent };